import { defineComponent } from "vue";
import AudioControl from "../AudioControl.vue.mjs";
import ScreenShareControl from "../ScreenShareControl/Index.vue.mjs";
import FullScreenControl from "../FullScreenControl.vue.mjs";
import InviteControl from "../InviteControl.vue.mjs";
import VideoControl from "../VideoControl.vue.mjs";
import ManageMemberControl from "../ManageMemberControl.vue.mjs";
import ChatControl from "../ChatControl.vue.mjs";
import MasterApplyControl from "../ManageStageControl.vue.mjs";
import MemberApplyControl from "../ApplyControl/MemberApplyControl.vue.mjs";
import MoreControl from "../MoreControl/index.mjs";
import EndControl from "../EndControl/index.mjs";
import SettingControl from "../SettingControl.vue.mjs";
import WhiteboardControl from "../WhiteboardControl.vue.mjs";
import VirtualBackground from "../VirtualBackground.vue.mjs";
import AIControl from "../AIControl.vue.mjs";
import BasicBeauty from "../BasicBeauty.vue.mjs";
import bus from "../../../hooks/useMitt.mjs";
import useRoomFooter from "./useRoomFooterHooks.mjs";
import { isElectron } from "../../../utils/environment.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexPC",
  setup(__props) {
    const { roomStore, isMaster, isAdmin, isAudience } = useRoomFooter();
    function handleControlClick(name) {
      bus.emit("experience-communication", name);
    }
    return { __sfc: true, roomStore, isMaster, isAdmin, isAudience, handleControlClick, AudioControl, ScreenShareControl, FullScreenControl, InviteControl, VideoControl, ManageMemberControl, ChatControl, MasterApplyControl, MemberApplyControl, MoreControl, EndControl, SettingControl, WhiteboardControl, VirtualBackground, AIControl, BasicBeauty, isElectron };
  }
});
export {
  _sfc_main as default
};
